module.exports = __webpack_public_path__ + "pexels-sarah-chai-7262387.jpg?b362bc14f38a53ddad694814584499c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/pexels-sarah-chai-7262387.jpg
// module id = 335
// module chunks = 0